import React, { Component } from 'react'
import '../../../../../assets/css/dormV2/Filter.css'
import { cloneDeep } from 'lodash-es'
import { Form,Button} from 'antd';


// 初始筛选器数据
const initFilterData = [
  {
    categoryName: '房间类型',
    id: 'fjlx',
    isFlod: false,
    optionFontSize: 'large',
    foldBoxHeight: 'small',
    options: []
  }
]

// 用于重置筛选条件
let filterDataBackup = []

class Filter extends Component {
  state = {
    foldStatus: 'unfolded',
    filterBoxEle: null,
    sectionHeight: 0,
    filterData: initFilterData,
  }

  componentDidMount() {
    this.getSectionHeight()
    this.saveFilterBoxEle()
  }

  // 保存dom元素
  saveFilterBoxEle = () => {
    this.setState({ filterBoxEle: document.getElementById('filterBox') })
  }

  // 获取section高度
  getSectionHeight = () => {
    this.setState({ sectionHeight: document.getElementById('optionsBox').offsetHeight })
  }

  // 更新筛选条件
  updateFilterData = (data,sfxssfbz) => {
    const { filterData } = this.state
    const newFilterData = cloneDeep(filterData)


    newFilterData.forEach(category => {
      if (category.id === 'fjlx') {
        const options = []
        data.cwsList.forEach(item => {
          options.push({
            id: item,
            describe: `${item}人间`,
            value: item,
            selectStatus: false
          })
        })
        category.options = options
      } 
    })

    this.setState({ filterData: newFilterData }, this.getSectionHeight)
    filterDataBackup = newFilterData
    return newFilterData
  }

  // 点击筛选选项
  selectOption = (categoryId, optionId) => {
    const { filterData } = this.state
    const newFilterData = cloneDeep(filterData)
    newFilterData.forEach(item => {
      if (item.id === categoryId) {
        item.options.forEach(option => {
          option.selectStatus = false
          option.id === optionId && (option.selectStatus = true)
        })
      }
    })
    this.setState({ filterData: newFilterData },()=>{this.search()})
  }

  // 整理筛选参数
  getFilterParams = data => {
    const searchParams = {}
    data.forEach(item => {
      const selectedOption = item.options.filter(option => option.selectStatus)[0]

     if (item.id === 'fjlx') {
        searchParams.cws = selectedOption?.value
      } 
    })
    return searchParams
  }


  // 查询
  search = () => {
    const { onSearch } = this.props
    const { filterData } = this.state
    if (onSearch) {
      const searchParams = this.getFilterParams(filterData)
      onSearch(searchParams)
      this.props.updateVisible();
    }
  }

  // 重置
  reset = () => {
    const { onSearch } = this.props
    this.setState({ filterData: filterDataBackup })
    if (onSearch) {
      const searchParams = this.getFilterParams(filterDataBackup)
      onSearch(searchParams)
    }
  }

  render() {
    const {  filterData } = this.state
    const { form } = this.props;
    return (
      <div>
      <div className='dormV2-filter' style={{height:'78px',overflow:"visible"}} id="filterBox">
        <section id="optionsBox" className='selfSection' style={{display:'block'}}>
          <ul>
            {
              
            filterData.map(category => {
              return (
                <Form>
                  <div className="p-sw">
                    <div style={{ border: "1px solid #eaeeed" }}>
                      <div  className="p-sw-header">
                        <li key={category.id}>
                          <div className="label label-style">{category.categoryName}：</div>
                          <div className="options options-style" style={{columnGap: '40px'}}>
                            {category.options.map(option => {
                              let flag = this.props.cwsStatus?.find(item => item.cws == option.value)?.allSycwZero;
                              return (
                                <Button disabled={flag} key={option.id} className="reset" onClick={() => {
                                  this.selectOption(category.id, option.id)
                                }}>
                                   {flag == true ? option.describe + "【已满】" : option.describe}
                                </Button>
                                // 灰色按钮样式
                                // <div
                                //   key={option.id}
                                //   className={option.selectStatus ? 'option selected' : 'option'}
                                //   onClick={() => {
                                //     this.selectOption(category.id, option.id)
                                //   }}
                                // >
                                //   {option.describe}
                                // </div>
                              )
                            })}
                          </div>
                        </li>
                      </div>
                    </div>
                  </div>
                </Form>

              )
            })}
          </ul>
        </section>
      </div>
      </div>
    )
  }
}
const FilterForm = Form.create()(Filter);
export default FilterForm;